import { createContext, ReactNode, useContext } from 'react';
import { SimpleField, TransactionTooltips } from '../types';

interface TransactionDetailContextValue {
  tooltips?: TransactionTooltips;
  isSelected?: boolean;
  fields?: (string | SimpleField)[];
}

const TransactionDetailSectionContext = createContext<
  TransactionDetailContextValue | undefined
>(undefined);

interface TransactionDetailSectionProviderProps {
  children: ReactNode;
  value: TransactionDetailContextValue;
}

export const TransactionDetailSectionProvider = ({
  children,
  value,
}: TransactionDetailSectionProviderProps) => {
  return (
    <TransactionDetailSectionContext.Provider value={value}>
      {children}
    </TransactionDetailSectionContext.Provider>
  );
};

export const useTransactionDetailSectionContext = () => {
  const context = useContext(TransactionDetailSectionContext);
  if (context === undefined) {
    throw new Error(
      'useTransactionDetailSectionContext must be used within a TransactionDetailProvider'
    );
  }
  return context;
};
